import React from 'react'
import Img from '@/lib/Img'
import CTA from '@/lib/CTA'

const ProgramStatic = ({ title, subtitle, image, cta }) => (
	<dl className="richtext-sm">
		<dt className="richtext-sm">
			<figure className="rounded-full overflow-hidden">
				<Img image={image} alt={title} />
			</figure>
			<p className="h2">{title}</p>
		</dt>
		<dd className="richtext-sm">
			<p>{subtitle}</p>
			<p><CTA {...cta} /></p>
		</dd>
	</dl>
)

export default ProgramStatic
